var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownLeftArrowBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V5C22 3.34315 20.6569 2 19 2H5ZM17.5303 7.53033L8.81066 16.25H15.1967C15.6109 16.25 15.9467 16.5858 15.9467 17C15.9467 17.4142 15.6109 17.75 15.1967 17.75H7C6.58579 17.75 6.25 17.4142 6.25 17V8.80328C6.25 8.38906 6.58579 8.05328 7 8.05328C7.41421 8.05328 7.75 8.38906 7.75 8.80328V15.1893L16.4697 6.46967C16.7626 6.17678 17.2374 6.17678 17.5303 6.46967C17.8232 6.76256 17.8232 7.23744 17.5303 7.53033Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownLeftArrowBox);
export default __webpack_public_path__ + "static/media/down-left-arrow-box.96e707d4cdde4a3e3e962984664cdd5b.svg";
export { ForwardRef as ReactComponent };